import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const STUDENTS_QUERY_KEY = 'students';

// Custom hook for fetching students
export const useStudents = (page = 1, limit = 10, search = '') => {
  return useQuery({
    queryKey: [STUDENTS_QUERY_KEY, page, limit, search],
    queryFn: () => apiClient.students.getAll(page, limit, search),
    keepPreviousData: true, // Keep previous data while fetching new data
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Custom hook for creating a student
export const useCreateStudent = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (studentData) => apiClient.students.create(studentData),
    onSuccess: () => {
      // Invalidate and refetch students data
      queryClient.invalidateQueries({ queryKey: [STUDENTS_QUERY_KEY] });
    },
  });
};

// Custom hook for updating a student
export const useUpdateStudent = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, studentData }) => apiClient.students.update(id, studentData),
    onSuccess: () => {
      // Invalidate and refetch students data
      queryClient.invalidateQueries({ queryKey: [STUDENTS_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting a student
export const useDeleteStudent = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.students.delete(id),
    onSuccess: () => {
      // Invalidate and refetch students data
      queryClient.invalidateQueries({ queryKey: [STUDENTS_QUERY_KEY] });
    },
  });
};

// Custom hook for getting a single student
export const useStudent = (id) => {
  return useQuery({
    queryKey: [STUDENTS_QUERY_KEY, id],
    queryFn: () => apiClient.students.getById(id),
    enabled: !!id, // Only run query if id exists
  });
}; 